"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSingleInputDialog = exports.SingleInputDialog = void 0;
var Dialog_1 = require("./Dialog");
var react_1 = __importStar(require("react"));
var morse_react_1 = require("morse-react");
var yup_1 = require("yup");
var SingleInputDialog = function (props) {
    var message = props.message, inputProps = props.inputProps, submitButtonProps = props.submitButtonProps, cancelButtonProps = props.cancelButtonProps, validationSchema = props.validationSchema, validationAlertProps = props.validationAlertProps, onSubmit = props.onSubmit, dialogProps = __rest(props, ["message", "inputProps", "submitButtonProps", "cancelButtonProps", "validationSchema", "validationAlertProps", "onSubmit"]);
    var _a = react_1.useState(props.initialValue), value = _a[0], setValue = _a[1];
    var _b = react_1.useState(), validationError = _b[0], setValidationError = _b[1];
    var onClickSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setValidationError(undefined);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!props.validationSchema) return [3 /*break*/, 3];
                    return [4 /*yield*/, props.validationSchema.validate(value)];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    _a = props.onSubmit;
                    if (!_a) return [3 /*break*/, 5];
                    return [4 /*yield*/, props.onSubmit(value)];
                case 4:
                    _a = (_b.sent());
                    _b.label = 5;
                case 5:
                    _a;
                    props.onDismissed && props.onDismissed();
                    return [3 /*break*/, 7];
                case 6:
                    e_1 = _b.sent();
                    if (e_1 instanceof yup_1.ValidationError) {
                        setValidationError(e_1.errors.join(". "));
                    }
                    else {
                        setValidationError("Unknown Error");
                    }
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var onClickCancel = function () {
        props.onDismissed && props.onDismissed();
    };
    var onInputChange = function (e) {
        setValue(e.target.value);
    };
    var onKeyUp = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(e.key === "Enter")) return [3 /*break*/, 2];
                    return [4 /*yield*/, onClickSubmit()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(Dialog_1.Dialog, __assign({}, dialogProps, { allowDismiss: true, buttons: [
            react_1.default.createElement(morse_react_1.Button, __assign({ onClick: onClickSubmit }, props.submitButtonProps, { tabIndex: 1 })),
            react_1.default.createElement(morse_react_1.Button, __assign({ onClick: onClickCancel }, props.cancelButtonProps, { tabIndex: 2 })),
        ] }),
        message && message,
        validationError && (react_1.default.createElement("div", { className: "u-marg-bottom" },
            react_1.default.createElement(morse_react_1.Alert, __assign({}, validationAlertProps), validationError))),
        react_1.default.createElement(morse_react_1.Input, __assign({ value: value }, inputProps, { onChange: onInputChange, autoFocus: true, onKeyUp: onKeyUp, tabIndex: 0 }))));
};
exports.SingleInputDialog = SingleInputDialog;
var useSingleInputDialog = function (props) {
    var dialogBroker = Dialog_1.useDialog();
    return {
        show: function (initialValue) {
            return new Promise(function (resolve, reject) {
                dialogBroker.show(react_1.default.createElement(exports.SingleInputDialog, __assign({ key: morse_react_1.PortalManager.getPortalCount(), initialValue: initialValue }, props, { onSubmit: function (value) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!props.onSubmit) return [3 /*break*/, 2];
                                    return [4 /*yield*/, props.onSubmit(value)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    dialogBroker.close();
                                    resolve(value);
                                    return [2 /*return*/];
                            }
                        });
                    }); }, onDismissed: function () {
                        dialogBroker.close();
                        reject();
                    } })));
            });
        },
        close: function () {
            if (dialogBroker) {
                dialogBroker.close();
            }
        },
    };
};
exports.useSingleInputDialog = useSingleInputDialog;
//# sourceMappingURL=SingleInputDialog.js.map